import { MovementManager } from "../../../Managers/MovementManager";
import { Position, IPiece, MoveType, ISideEffect } from "../../../types";
import { InkMoveHandler } from "./InkMoveHandler";
import { SwingMoveHandler } from "./SwingMoveHandler";
import { ConsumeMoveHandler } from "./ConsumeMoveHandler";

export type MoveHandlerParams = {
  movementManager: MovementManager;
  fromPosition: Position;
  toPosition: Position;
  piece: IPiece;
  toPiece?: IPiece | null;
  sideEffects?: ISideEffect[];
};

export interface IMoveHandler {
  handleMove(params: MoveHandlerParams): void;
}

export function GetMoveHandler(moveType: MoveType): IMoveHandler {
  switch (moveType) {
    case MoveType.ink:
      return new InkMoveHandler();
    case MoveType.swing:
      return new SwingMoveHandler();
    case MoveType.consume:
      return new ConsumeMoveHandler();
    default:
      throw new Error(`No handler defined for ${moveType}`);
  }
}
